import { Box, keyframes } from "@mui/material";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const MarterIcon = () => (
	<Box
		component="img"
		src="/assets/marter.png"
		alt=""
		sx={{
			width: 20,
			height: 20,
			borderRadius: "50%",
			"&:hover": {
				animation: `${spin} 1s linear infinite`,
			},
		}}
	/>
);
